export const EasingTypes = {
	Linear: 'linear',
	Sine: 'sine',
	Circular: 'circular',
	Cubic: 'cubic',
	Bounce: 'bounce',
	Elastic: 'elastic',
	Expo: 'expo',
	Quadratic: 'quadratic',
	Back: 'back',
	Quintic: 'quintic',
} as const

export const EasingDirections = {
	In: 'In',
	Out: 'Out',
	InOut: 'InOut',
} as const

export type EasingType = (typeof EasingTypes)[keyof typeof EasingTypes]
export type EasingDirection = (typeof EasingDirections)[keyof typeof EasingDirections]

export class Easing {
	type!: EasingType
	direction?: EasingDirection
}

export const easingTypes = Object.values(EasingTypes) as EasingType[]
export const easingDirections = Object.values(EasingDirections) as EasingDirection[]
